// Import des libs
import * as bootstrap from 'bootstrap';
import * as Popper from '@popperjs/core';
import jQuery from 'jquery';
import Swal from 'sweetalert2';
import * as toastr from 'toastr';
// @ts-ignore
import { scrollCue } from '../libs/scrollCue/scrollCue.js';

// Import du Kernel
import DataStorage from '../../../common/utils/DataStorage';
import Kernel from '../../../common/utils/Kernel';

// RGPD
import '../../../common/vendor/hegyd/rgpd/js/cookies';

// Déclaration de mes variables partagés

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
(window as any).Popper = Popper;

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
(window as any).bootstrap = bootstrap;

// (requis par toastr -_-")
(window as any).jQuery = jQuery;
(window as any).$ = jQuery;

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
(window as any).toastr = toastr;

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
(window as any).Swal = Swal;
(window as any).swal = (window as any).Swal;

/** A storage solution aimed at replacing jQuerys data function.
 * Implementation Note: Elements are stored in a (WeakMap)[https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap].
 * This makes sure the data is garbage collected when the node is removed.
 */
(window as any).dataStorage = DataStorage;

// Kernel permettant de monter les componants data-mount
(window as any).Kernel = Kernel;

// Components
Kernel.registerComponent('Header', require('./components/Header').default);

document.addEventListener('DOMContentLoaded', () => {
    Kernel.mountComponents(document.querySelector('body'));
    scrollCue.init();
});
